// import React, { useState, useCallback, useRef } from 'react';
// import {
//    Box,
//    Button,
//    Flex,
//    Grid,
//    GridItem,
//    Modal,
//    ModalBody,
//    ModalCloseButton,
//    ModalContent,
//    ModalHeader,
//    ModalOverlay,
//    useColorModeValue,
//    Text,
//    Switch,
//    IconButton,
//    ModalFooter,
//    Heading,
// } from '@chakra-ui/react';
// import InputField from 'components/ui/InputField';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { useSelector, useDispatch } from 'react-redux';
// import { AddIcon, CloseIcon } from '@chakra-ui/icons';
// import { useEffect } from 'react';
// import { getReportStockDetail } from '../../../../../redux/actions/GlobalIMEI';
// import { useUser } from 'contexts/UserContext';
// import moment from 'moment';
// import { getPurchaseInvoice } from '../../../../../redux/actions/purchaseInvoice';
// import { toast } from 'react-toastify';

// const ExchangeModal = ({
//    isOpen,
//    onClose,
//    setExchange,
//    exchange,
//    data,
//    handleAskToVerifyCustomer,
//    daybookPaymentData,
//    setExchangePayments,
//    selectedDaybook,
// }) => {
//    const dispatch = useDispatch();
//    const textColor = useColorModeValue('gray.800', 'white');
//    const [fields, setFields] = useState([
//       {
//          purchaseId: '',
//          itemId: '',
//          itemRate: '',
//          note1: '',
//          isOld: true,
//          serialNo: '',
//          serialNo2: '',
//          isDelete: false,
//       },
//    ]);
//    const [errors, setErrors] = useState({});
//    const { user } = useUser();
//    const [paymentData, setPaymentData] = useState([]);
//    const [serial, setSerial] = useState([]);
//    const [isNewItemAdded, setIsNewItemAdded] = useState(false);
//    const [newItemIndex, setNewItemIndex] = useState(-1);
//    const [isLoading, setIsLoading] = useState(false);

//    const lastSearchRef = useRef('');
//    const debounceTimeout = useRef(null);
//    const itemData = useSelector((state) => state.item?.list);
//    const itemRef = useRef([]);
//    const rateRef = useRef([]);
//    const noteRef = useRef([]);
//    const serialNoRef = useRef([]);
//    const serialNo2Ref = useRef([]);
//    const isOldRef = useRef([]);
//    const addRef = useRef([]);
//    const deleteRef = useRef([]);
//    const amountRef = useRef([]);
//    const saveButtonRef = useRef(null);
//    const closeButtonRef = useRef(null);
//    const prevFieldsLength = useRef(fields?.length);

//    const purchaseInvoice = useSelector((state) => state.purchaseInvoice?.single);

//    const isItemEmpty = (item) => {
//       return !item.itemId && item.itemRate === 0 && !item.note1 && !item.serialNo && !item.serialNo2;
//    };

//    const handleSearch = useCallback(
//       async (value, idx) => {
//          setIsLoading(true);
//          lastSearchRef.current = value;
//          const params = {
//             companyIds: user?.loginhistory?.companyId,
//             fromDate: '2024-01-01',
//             toDate: moment().add(1, 'days').format('YYYY-MM-DD'),
//             stockStatus: 2,
//             serialNo: value,
//             // itemIds: fields[idx].itemId,
//          };

//          const newRows = [...fields];
//          const res = await dispatch(getReportStockDetail(params));
//          if (res.code === 1 && res.data?.length > 0) {
//             newRows[idx].serialNo = '';
//             setFields(newRows);
//             setIsLoading(false);
//          }
//          if (res.code === 2) {
//             newRows[idx].serialNo = '';
//             setFields(newRows);
//             setIsLoading(false);
//          }
//          setIsLoading(false);
//          return res;
//       },
//       [dispatch, fields, user?.loginhistory?.companyId],
//    );

//    // const removeEmptyNewItem = useCallback(() => {
//    //    if (isNewItemAdded && newItemIndex >= 0 && newItemIndex < fields.length) {
//    //       const itemToCheck = fields[newItemIndex];
//    //       if (isItemEmpty(itemToCheck)) {
//    //          setFields((prevFields) => {
//    //             const updatedFields = prevFields.filter((_, index) => index !== newItemIndex);
//    //             return updatedFields;
//    //          });
//    //          setIsNewItemAdded(false);
//    //          setNewItemIndex(-1);
//    //       }
//    //    }
//    // }, [isNewItemAdded, newItemIndex, fields]);

//    useEffect(() => {
//       if (fields?.length > prevFieldsLength.current) {
//          const newIndex = fields?.length - 1;
//          setIsNewItemAdded(true);
//          setNewItemIndex(newIndex);
//          itemRef.current[newIndex]?.focus();
//       }
//       prevFieldsLength.current = fields?.length;
//    }, [fields?.length]);

//    const handleExchangeOnChangeInput = useCallback(
//       async (e, index, value, fieldName) => {
//          const newExchangeData = [...fields];

//          // Handle Switch component (for isOld field)
//          if (fieldName === 'isOld') {
//             newExchangeData[index][fieldName] = fields[index].isOld === true ? false : true; // e is the boolean value for Switch
//          }
//          if (fieldName === 'itemId') {
//             newExchangeData[index]['itemId'] = value;
//          }
//          // Handle dropdown selection
//          else if (!e && value) {
//             newExchangeData[index]['itemId'] = value;
//             if (value && isNewItemAdded && index === newItemIndex) {
//                setIsNewItemAdded(false);
//                setNewItemIndex(-1);
//             }
//          }
//          // Handle regular input fields
//          else if (e && e.target) {
//             const { name, value } = e.target;
//             newExchangeData[index][name] = value;

//             const newErrors = { ...errors };
//             if (name === 'serialNo') {
//                if (value.trim() !== '' && value.trim()?.length < 10) {
//                   newErrors[`serialNo_${index}`] = 'Serial number must be at least 10 characters.';
//                } else {
//                   delete newErrors[`serialNo_${index}`];
//                }
//                setErrors(newErrors);
//             }

//             if (name === 'serialNo') {
//                if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
//                debounceTimeout.current = setTimeout(async () => {
//                   if (value.trim() !== '' && value.trim()?.length > 10) {
//                      await handleSearch(value.trim(), index);
//                   }

//                   const trimmedValue = value.trim();
//                   const isDuplicate = serial.includes(trimmedValue);
//                   console.log('test', trimmedValue, serial);
//                   if (isDuplicate) {
//                      toast.error(`Duplicate serial number: ${trimmedValue}`);
//                      newExchangeData[index][name] = '';
//                      setSerial((prev) => {
//                         const updated = [...prev]; // copy the array
//                         updated[index] = ''; // update specific index
//                         return updated;
//                      });
//                      return;
//                   }
//                }, 500);
//             }
//          }

//          setIsLoading(false);
//          setFields(newExchangeData);
//          if (e && e.target) {
//             const { name, value } = e.target;
//             if (name === 'serialNo') {
//                setTimeout(() => {
//                   setSerial((prev) => {
//                      const updated = [...prev]; // copy the array
//                      updated[index] = value; // update specific index
//                      return updated;
//                   });
//                }, 600);
//             }
//          }
//       },
//       [errors, fields, handleSearch, isNewItemAdded, newItemIndex, serial],
//    );

//    useEffect(() => {
//       if (isOpen && data) {
//          const mappedFields = purchaseInvoice?.lineitems?.flatMap((item) =>
//             item?.purchaseLineDetail?.map((subdata) => ({
//                purchaseId: purchaseInvoice?.id || '',
//                id: item.id || '',
//                salesLineDetailId: subdata.id || '',
//                itemId: item.itemId || '',
//                itemRate: item.itemRate || 0,
//                isDelete: item.isDelete || false,
//                note1: subdata.notes1 || '',
//                isOld: subdata.isOld ?? true,
//                serialNo: subdata.serialNo || '',
//                serialNo2: subdata.serialNo2 || '',
//             })),
//          );
//          if (mappedFields) {
//             setFields(mappedFields);
//          } else {
//             setFields([
//                {
//                   purchaseId: '',
//                   itemId: '',
//                   itemRate: '',
//                   note1: '',
//                   isOld: true,
//                   serialNo: '',
//                   serialNo2: '',
//                   isDelete: false,
//                },
//             ]);
//          }

//          // setFields(...mappedFields);
//          console.log('mappedFields', mappedFields, mappedFields?.length);
//          // setFields(mappedFields);
//       }
//    }, [data, isOpen, purchaseInvoice?.id, purchaseInvoice?.lineitems, purchaseInvoice?.lineitems?.length]);

//    useEffect(() => {
//       if (isOpen && data) {
//          const vouchers = purchaseInvoice?.vouchers;
//          if (vouchers) {
//             setPaymentData((prevPaymentData) => {
//                const updatedPaymentData = prevPaymentData.map((pay) => {
//                   const adjustment = vouchers.find((a) => a.daybookId === pay.daybookId);
//                   return {
//                      ...pay,
//                      id: adjustment?.id || null,
//                      amount: adjustment?.amount || 0,
//                      outAdjustmentId: adjustment?.outAdjustmentId,
//                   };
//                });
//                return updatedPaymentData;
//             });
//          }
//       }
//       return () => { };
//    }, [data, isOpen, purchaseInvoice?.vouchers]);

//    const addField = () => {
//       setFields([
//          ...fields,
//          {
//             purchaseId: '',
//             itemId: '',
//             itemRate: 0,
//             note1: '',
//             isOld: true,
//             isDelete: false,
//             serialNo: '',
//             serialNo2: '',
//          },
//       ]);
//    };

//    // const removeField = (index) => {
//    //     const updated = fields.filter((_, i) => i !== index);
//    //     setFields(updated);
//    //     if (index === newItemIndex) {
//    //        setIsNewItemAdded(false);
//    //        setNewItemIndex(-1);
//    //     }
//    // };

//    const removeField = (index) => {
//       setFields((prevFields) => {
//          const updatedFields = [...prevFields];
//          const field = updatedFields[index];

//          if (field?.id) {
//             // ✅ If the record exists in DB (has id), mark as deleted
//             updatedFields[index] = {
//                ...field,
//                isDelete: true, // or isDeleted, depending on your backend
//             };
//          } else {
//             // ✅ If the record is new (no id), just remove it from the array
//             updatedFields.splice(index, 1);
//          }

//          return updatedFields;
//       });

//       // Reset "new item" state if this was the new item
//       if (index === newItemIndex) {
//          setIsNewItemAdded(false);
//          setNewItemIndex(-1);
//       }
//    };

//    const handleExchangeClose = () => {
//       setFields([
//          {
//             purchaseId: '',
//             itemId: '',
//             itemRate: 0,
//             note1: '',
//             isDelete: false,
//             isOld: true,
//             serialNo: '',
//             serialNo2: '',
//          },
//       ]);
//       setIsNewItemAdded(false);
//       setNewItemIndex(-1);
//       onClose();
//    };

//    const handleExchange = async () => {
//       const isVerified = handleAskToVerifyCustomer(fields, paymentData);
//       console.log('fields', fields);
//       if (isVerified) {
//          setExchange(fields);
//          setExchangePayments(paymentData);
//          onClose();
//       } else {
//          setExchange(fields);
//          setExchangePayments(paymentData);
//          onClose();
//       }
//    };

//    const handlePaymentOnChange = useCallback(
//       (e, index) => {
//          const { name, value } = e.target;
//          const newPaymentData = [...paymentData];
//          newPaymentData[index][name] = value;
//          setPaymentData(newPaymentData);
//       },
//       [paymentData],
//    );

//    const handlePaymentFieldFocus = (paymentIndex) => {
//       if (isNewItemAdded && newItemIndex >= 0 && newItemIndex < fields?.length) {
//          const itemToCheck = fields[newItemIndex];
//          if (isItemEmpty(itemToCheck)) {
//             setFields((prevFields) => {
//                const updatedFields = prevFields.filter((_, index) => index !== newItemIndex);
//                return updatedFields;
//             });
//             setIsNewItemAdded(false);
//             setNewItemIndex(-1);
//             setTimeout(() => {
//                amountRef.current[paymentIndex]?.focus();
//             }, 10);
//             return;
//          }
//       }
//       setTimeout(() => {
//          amountRef.current[paymentIndex]?.focus();
//       }, 0);
//    };

//    const handleRateKeyDown = (e, index) => {
//       if (e.key === 'Enter' || e.key === 'Tab') {
//          e.preventDefault();
//          if (isNewItemAdded && !fields[index].itemId && paymentData?.length > 0) {
//             handlePaymentFieldFocus(0);
//          } else {
//             noteRef.current[index]?.focus();
//          }
//       }
//    };

//    const handleNoteKeyDown = (e, index) => {
//       if (e.key === 'Enter' || e.key === 'Tab') {
//          e.preventDefault();
//          if (isNewItemAdded && !fields[index].itemId && paymentData?.length > 0) {
//             handlePaymentFieldFocus(0);
//          } else {
//             serialNoRef.current[index]?.focus();
//          }
//       }
//    };

//    const handleSerialNoKeyDown = (e, index) => {
//       if (e.key === 'Enter' || e.key === 'Tab') {
//          e.preventDefault();
//          if (isNewItemAdded && !fields[index].itemId && paymentData?.length > 0) {
//             handlePaymentFieldFocus(0);
//          } else {
//             serialNo2Ref.current[index]?.focus();
//          }
//       }
//    };

//    const handleSerialNo2KeyDown = (e, index) => {
//       if (e.key === 'Enter' || e.key === 'Tab') {
//          e.preventDefault();
//          if (isNewItemAdded && !fields[index].itemId) {
//             handlePaymentFieldFocus(0);
//          } else if (index === fields.length - 1) {
//             // If this is the last field, focus on add button or first payment field
//             // if (paymentData?.length > 0) {
//             //    amountRef.current[0]?.focus();
//             // } else {
//             //    addRef.current[index]?.focus();
//             // }
//             if (addRef.current[index]) {
//                addRef.current[index]?.focus();
//             } else {
//                amountRef.current[0]?.focus();
//             }
//          } else {
//             // Move to next field's item dropdown
//             itemRef.current[index + 1]?.focus();
//          }
//       }
//    };
//    const getData = useCallback(async () => {
//       if (isOpen && data && data?.id) {
//          await dispatch(getPurchaseInvoice(data.id));
//       }
//    }, [data, dispatch, isOpen]);

//    useEffect(() => {
//       if (exchange?.length > 0) {
//          setFields(exchange);
//       }
//    }, [exchange]);

//    useEffect(() => {
//       if (daybookPaymentData?.length > 0) {
//          const payment = daybookPaymentData?.map((payment) => {
//             return { daybookName: payment.name, daybookId: payment.id, amount: 0 };
//          });
//          setPaymentData(payment);
//       }
//    }, [daybookPaymentData, daybookPaymentData?.length]);

//    useEffect(() => {
//       setTimeout(() => {
//          itemRef.current[0]?.focus();
//       }, 100);
//    }, [isOpen]);

//    useEffect(() => {
//       getData();
//    }, [getData]);

//    return (
//       <>
//          <Modal isOpen={isOpen} onClose={handleExchangeClose} size="5xl">
//             <ModalOverlay />
//             <ModalContent
//                bg={useColorModeValue('white', '#2d3748')}
//                color={useColorModeValue('gray.800', 'white')}
//                borderRadius="20px"
//                boxShadow="lg"
//                width="fit-content">
//                <ModalHeader>Add Exchange</ModalHeader>
//                <ModalCloseButton />

//                <ModalBody>
//                   <Box maxH="500px" overflowY="scroll">
//                      {fields?.map((field, index) => (
//                         <Box
//                            key={index}
//                            border="1px solid"
//                            borderColor={field?.isDelete ? 'red.400' : 'gray.200'} // 🔴 red border if deleted
//                            bg={field?.isDelete ? 'red.50' : 'transparent'} // 🔴 light red background
//                            // borderColor="gray.200"
//                            p="20px"
//                            borderRadius="md"
//                            mb={4}
//                            width="fit-content"
//                            opacity={field?.isDelete ? 0.7 : 1} // optional dim effect
//                         >
//                            <Grid display="flex">
//                               <GridItem mr="15px">
//                                  <Flex gap={5} mb={15}>
//                                     <Box minWidth="400px">
//                                        {renderDynamicDropdown(
//                                           'itemId',
//                                           'Item',
//                                           itemData,
//                                           {
//                                              value: field?.itemId,
//                                              onChange: (value) =>
//                                                 handleExchangeOnChangeInput(null, index, value, 'itemId'),
//                                              disabled: field?.isDelete,
//                                              focusBorderColor: 'blue.500',
//                                              _focus: {
//                                                 boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
//                                              },
//                                              showCustomNoOptions: true,
//                                              openfrom: 'item',
//                                              ref: (el) => {
//                                                 itemRef.current[index] = el;
//                                                 if (
//                                                    index === fields?.length - 1 &&
//                                                    fields?.length > prevFieldsLength.current
//                                                 ) {
//                                                    setTimeout(() => el?.focus(), 0);
//                                                 }
//                                              },
//                                              onKeyDown: async (e) => {
//                                                 if (e.key === 'Enter' || e.key === 'Tab') {
//                                                    e.preventDefault();
//                                                    if (isNewItemAdded && !field.itemId) {
//                                                       handlePaymentFieldFocus(0);
//                                                    } else {
//                                                       rateRef.current[index]?.focus();
//                                                    }
//                                                 }
//                                              },
//                                           },
//                                           {},
//                                           textColor,
//                                           false,
//                                           'Select Item',
//                                        )}
//                                     </Box>
//                                     <InputField
//                                        name="itemRate"
//                                        ref={(el) => (rateRef.current[index] = el)}
//                                        label="Rate"
//                                        type="number"
//                                        value={field.itemRate}
//                                        onChange={(e) => handleExchangeOnChangeInput(e, index, null)}
//                                        onKeyDown={(e) => handleRateKeyDown(e, index)}
//                                        isDisabled={field?.isDelete} // 🔴 disable input
//                                     />
//                                     <InputField
//                                        name="note1"
//                                        ref={(el) => (noteRef.current[index] = el)}
//                                        label="Note 1"
//                                        type="text"
//                                        value={field.note1}
//                                        onChange={(e) => handleExchangeOnChangeInput(e, index, null)}
//                                        onKeyDown={(e) => handleNoteKeyDown(e, index)}
//                                        isDisabled={field?.isDelete} // 🔴 disable input
//                                     />
//                                  </Flex>
//                                  <Flex gap={5}>
//                                     <InputField
//                                        name="serialNo"
//                                        ref={(el) => (serialNoRef.current[index] = el)}
//                                        label="Serial No 1"
//                                        type="text"
//                                        value={field.serialNo}
//                                        onChange={(e) => handleExchangeOnChangeInput(e, index, null)}
//                                        onKeyDown={(e) => handleSerialNoKeyDown(e, index)}
//                                        errorName={`serialNo_${index}`}
//                                        errors={errors}
//                                        isDisabled={field?.isDelete} // 🔴 disable input
//                                     />
//                                     <InputField
//                                        name="serialNo2"
//                                        ref={(el) => (serialNo2Ref.current[index] = el)}
//                                        label="Serial No 2"
//                                        type="text"
//                                        value={field.serialNo2}
//                                        onChange={(e) => handleExchangeOnChangeInput(e, index, null)}
//                                        onKeyDown={(e) => handleSerialNo2KeyDown(e, index)}
//                                        isDisabled={field?.isDelete} // 🔴 disable input
//                                     />
//                                  </Flex>
//                               </GridItem>
//                               <GridItem justifyItems="center">
//                                  <Flex
//                                     align="center"
//                                     gap={9}
//                                     border="1px solid #9E9E9E"
//                                     px={5}
//                                     py={2}
//                                     borderRadius="md"
//                                     mb={15}>
//                                     <Text fontSize="15px">IsOld</Text>
//                                     <Switch
//                                        key={`isOld-${index}`}
//                                        ref={(el) => (isOldRef.current[index] = el)}
//                                        isChecked={field.isOld}
//                                        onChange={(e) => {
//                                           handleExchangeOnChangeInput(e.target.checked, index, null, 'isOld');
//                                        }}
//                                     />
//                                  </Flex>
//                                  <Flex gap={2}>
//                                     {index === fields?.length - 1 && (
//                                        <IconButton
//                                           icon={<AddIcon />}
//                                           colorScheme="green"
//                                           ref={(el) => (addRef.current[index] = el)}
//                                           onClick={addField}
//                                           aria-label="Add"
//                                           width="27px"
//                                           _focus={{ outlineColor: 'blue.500 ' }}
//                                        />
//                                     )}
//                                     <IconButton
//                                        icon={<CloseIcon />}
//                                        colorScheme="red"
//                                        ref={(el) => (deleteRef.current[index] = el)}
//                                        onClick={() => removeField(index)}
//                                        aria-label="Remove"
//                                        width="27px"
//                                        _focus={{ outlineColor: 'blue.500 ' }}
//                                     />
//                                  </Flex>
//                               </GridItem>
//                            </Grid>
//                         </Box>
//                      ))}
//                   </Box>
//                   <Box>
//                      <Box mb={3}>
//                         <Heading as="h3" size="lg">
//                            Payments
//                         </Heading>
//                      </Box>
//                      <Grid templateColumns="repeat(2, 1fr)" gap={3}>
//                         {paymentData?.map((payment, idx) => {
//                            return (
//                               <GridItem w="100%" key={idx}>
//                                  <InputField
//                                     type="number"
//                                     name={`amount`}
//                                     label={`${payment.daybookName} AMOUNT`}
//                                     value={payment.amount}
//                                     ref={(el) => (amountRef.current[idx] = el)}
//                                     onChange={(e) => handlePaymentOnChange(e, idx)}
//                                     onFocus={() => {
//                                        if (isNewItemAdded && newItemIndex >= 0 && newItemIndex < fields?.length) {
//                                           const itemToCheck = fields[newItemIndex];
//                                           if (isItemEmpty(itemToCheck)) {
//                                              setFields((prevFields) => {
//                                                 const updatedFields = prevFields.filter(
//                                                    (_, index) => index !== newItemIndex,
//                                                 );
//                                                 return updatedFields;
//                                              });
//                                              setIsNewItemAdded(false);
//                                              setNewItemIndex(-1);
//                                           }
//                                        }
//                                     }}
//                                     onKeyDown={(e) => {
//                                        if (e.key === 'Enter') {
//                                           e.preventDefault();
//                                           const nextRef = amountRef.current[idx + 1] || saveButtonRef.current;
//                                           nextRef?.focus();
//                                        }
//                                     }}
//                                  />
//                               </GridItem>
//                            );
//                         })}
//                      </Grid>
//                   </Box>
//                </ModalBody>
//                <ModalFooter gap={5}>
//                   <Button
//                      colorScheme="blue"
//                      onClick={() => handleExchange()}
//                      _focus={{ outlineColor: 'blue.500 ' }}
//                      ref={saveButtonRef}
//                      isLoading={isLoading}
//                      disabled={isLoading}>
//                      Save
//                   </Button>
//                   <Button
//                      colorScheme="red"
//                      onClick={() => handleExchangeClose()}
//                      _focus={{ outlineColor: 'blue.500 ' }}
//                      ref={closeButtonRef}>
//                      Close
//                   </Button>
//                </ModalFooter>
//             </ModalContent>
//          </Modal>
//       </>
//    );
// };

// export default ExchangeModal;

import React, { useState, useCallback, useRef } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalFooter,
   ModalCloseButton,
   Button,
   FormControl,
   FormLabel,
   Input,
   Switch,
   IconButton,
   Box,
   Flex,
   Grid,
   GridItem,
   Text,
   useColorMode,
   FormErrorMessage,
   useColorModeValue,
} from '@chakra-ui/react';
import { AddIcon, CloseIcon } from '@chakra-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getReportStockDetail } from '../../../../../redux/actions/GlobalIMEI';
import { useUser } from 'contexts/UserContext';
import moment from 'moment';
import { getPurchaseInvoice } from '../../../../../redux/actions/purchaseInvoice';
import { toast } from 'react-toastify';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import InputField from 'components/ui/InputField';

const ExchangeModal = ({
   isOpen,
   onClose,
   setExchange,
   exchange,
   data,
   handleAskToVerifyCustomer,
   daybookPaymentData,
   setExchangePayments,
   selectedDaybook,
}) => {
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const textColor = useColorModeValue('gray.800', 'white');
   const [fields, setFields] = useState([
      {
         purchaseId: '',
         itemId: '',
         itemRate: '',
         note1: '',
         isOld: true,
         serialNo: '',
         serialNo2: '',
         isDelete: false,
      },
   ]);
   const [errors, setErrors] = useState({});
   const { user } = useUser();
   const [paymentData, setPaymentData] = useState([]);
   const [serial, setSerial] = useState([]);
   const [isNewItemAdded, setIsNewItemAdded] = useState(false);
   const [newItemIndex, setNewItemIndex] = useState(-1);
   const [isLoading, setIsLoading] = useState(false);

   const lastSearchRef = useRef('');
   const debounceTimeout = useRef(null);
   const itemData = useSelector((state) => state.item?.list);
   const itemRef = useRef([]);
   const rateRef = useRef([]);
   const noteRef = useRef([]);
   const serialNoRef = useRef([]);
   const serialNo2Ref = useRef([]);
   const isOldRef = useRef([]);
   const addRef = useRef([]);
   const deleteRef = useRef([]);
   const amountRef = useRef([]);
   const saveButtonRef = useRef(null);
   const closeButtonRef = useRef(null);
   const prevFieldsLength = useRef(fields?.length);

   const purchaseInvoice = useSelector((state) => state.purchaseInvoice?.single);

   const isItemEmpty = (item) => {
      return !item.itemId && item.itemRate === 0 && !item.note1 && !item.serialNo && !item.serialNo2;
   };

   const handleSearch = useCallback(
      async (value, idx) => {
         setIsLoading(true);
         lastSearchRef.current = value;
         const params = {
            companyIds: user?.loginhistory?.companyId,
            fromDate: '2024-01-01',
            toDate: moment().add(1, 'days').format('YYYY-MM-DD'),
            stockStatus: 2,
            serialNo: value,
         };

         const newRows = [...fields];
         const res = await dispatch(getReportStockDetail(params));
         if (res.code === 1 && res.data?.length > 0) {
            newRows[idx].serialNo = '';
            setFields(newRows);
            setIsLoading(false);
         }
         if (res.code === 2) {
            newRows[idx].serialNo = '';
            setFields(newRows);
            setIsLoading(false);
         }
         setIsLoading(false);
         return res;
      },
      [dispatch, fields, user?.loginhistory?.companyId],
   );

   useEffect(() => {
      if (fields?.length > prevFieldsLength.current) {
         const newIndex = fields?.length - 1;
         setIsNewItemAdded(true);
         setNewItemIndex(newIndex);
         itemRef.current[newIndex]?.focus();
      }
      prevFieldsLength.current = fields?.length;
   }, [fields?.length]);

   const handleExchangeOnChangeInput = useCallback(
      async (e, index, value, fieldName) => {
         const newExchangeData = [...fields];

         if (fieldName === 'isOld') {
            newExchangeData[index][fieldName] = fields[index].isOld === true ? false : true;
         }
         if (fieldName === 'itemId') {
            newExchangeData[index]['itemId'] = value;
         } else if (!e && value) {
            newExchangeData[index]['itemId'] = value;
            if (value && isNewItemAdded && index === newItemIndex) {
               setIsNewItemAdded(false);
               setNewItemIndex(-1);
            }
         } else if (e && e.target) {
            const { name, value } = e.target;
            newExchangeData[index][name] = value;

            const newErrors = { ...errors };
            if (name === 'serialNo') {
               if (value.trim() !== '' && value.trim()?.length < 10) {
                  newErrors[`serialNo_${index}`] = 'Serial number must be at least 10 characters.';
               } else {
                  delete newErrors[`serialNo_${index}`];
               }
               setErrors(newErrors);
            }

            if (name === 'serialNo') {
               if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
               debounceTimeout.current = setTimeout(async () => {
                  if (value.trim() !== '' && value.trim()?.length >= 10) {
                     await handleSearch(value.trim(), index);
                  }

                  const trimmedValue = value.trim();
                  const isDuplicate = serial.includes(trimmedValue);
                  if (isDuplicate) {
                     toast.error(`Duplicate serial number: ${trimmedValue}`);
                     newExchangeData[index][name] = '';
                     setSerial((prev) => {
                        const updated = [...prev];
                        updated[index] = '';
                        return updated;
                     });
                     return;
                  }
               }, 500);
            }
         }

         setIsLoading(false);
         setFields(newExchangeData);
         if (e && e.target) {
            const { name, value } = e.target;
            if (name === 'serialNo') {
               setTimeout(() => {
                  setSerial((prev) => {
                     const updated = [...prev];
                     updated[index] = value;
                     return updated;
                  });
               }, 600);
            }
         }
      },
      [errors, fields, handleSearch, isNewItemAdded, newItemIndex, serial],
   );

   useEffect(() => {
      if (isOpen && data) {
         const mappedFields = purchaseInvoice?.lineitems?.flatMap((item) =>
            item?.purchaseLineDetail?.map((subdata) => ({
               purchaseId: purchaseInvoice?.id || '',
               id: item.id || '', // 👉 PURCHASE LINE ITEM ID
               salesLineDetailId: subdata.id || '', // 👉 PURCHASE LINE DETAIL ID
               itemId: item.itemId || '',
               itemRate: item.itemRate || 0,
               isDeleted: item.isDeleted || false,
               note1: subdata.notes1 || '',
               isOld: subdata.isOld ?? true,
               serialNo: subdata.serialNo || '',
               serialNo2: subdata.serialNo2 || '',
            })),
         );
         if (mappedFields) {
            setFields(mappedFields);
         } else {
            setFields([
               {
                  purchaseId: '',
                  itemId: '',
                  itemRate: '',
                  note1: '',
                  isOld: true,
                  serialNo: '',
                  serialNo2: '',
                  isDelete: false,
               },
            ]);
         }

         // setFields(...mappedFields);
         // console.log('mappedFields', mappedFields, mappedFields?.length);
         // setFields(mappedFields);
      }
   }, [data, isOpen, purchaseInvoice?.id, purchaseInvoice?.lineitems]);

   useEffect(() => {
      if (isOpen && data) {
         const vouchers = purchaseInvoice?.vouchers;
         if (vouchers) {
            setPaymentData((prevPaymentData) => {
               const updatedPaymentData = prevPaymentData.map((pay) => {
                  const adjustment = vouchers.find((a) => a.daybookId === pay.daybookId);
                  return {
                     ...pay,
                     id: adjustment?.id || null,
                     amount: adjustment?.amount || 0,
                     outAdjustmentId: adjustment?.outAdjustmentId,
                  };
               });
               return updatedPaymentData;
            });
         }
      }
      return () => {};
   }, [data, isOpen, purchaseInvoice?.vouchers]);

   const addField = () => {
      setFields([
         ...fields,
         {
            purchaseId: '',
            itemId: '',
            itemRate: 0,
            note1: '',
            isOld: true,
            isDelete: false,
            serialNo: '',
            serialNo2: '',
         },
      ]);
   };

   const removeField = (index) => {
      setFields((prevFields) => {
         const updatedFields = [...prevFields];
         const field = updatedFields[index];

         if (field?.id) {
            updatedFields[index] = {
               ...field,
               isDelete: true,
            };
         } else {
            updatedFields.splice(index, 1);
         }

         return updatedFields;
      });

      if (index === newItemIndex) {
         setIsNewItemAdded(false);
         setNewItemIndex(-1);
      }
   };

   const handleExchangeClose = () => {
      setFields([
         {
            purchaseId: '',
            itemId: '',
            itemRate: 0,
            note1: '',
            isDelete: false,
            isOld: true,
            serialNo: '',
            serialNo2: '',
         },
      ]);
      setIsNewItemAdded(false);
      setNewItemIndex(-1);
      onClose();
   };

   const handleExchange = async () => {
      const isVerified = handleAskToVerifyCustomer(fields, paymentData);
      if (isVerified) {
         setExchange(fields);
         setExchangePayments(paymentData);
         onClose();
      } else {
         setExchange(fields);
         setExchangePayments(paymentData);
         onClose();
      }
   };

   const handlePaymentOnChange = useCallback(
      (e, index) => {
         const { name, value } = e.target;
         const newPaymentData = [...paymentData];
         newPaymentData[index][name] = value;
         setPaymentData(newPaymentData);
      },
      [paymentData],
   );

   const handlePaymentFieldFocus = (paymentIndex) => {
      if (isNewItemAdded && newItemIndex >= 0 && newItemIndex < fields?.length) {
         const itemToCheck = fields[newItemIndex];
         if (isItemEmpty(itemToCheck)) {
            setFields((prevFields) => {
               const updatedFields = prevFields.filter((_, index) => index !== newItemIndex);
               return updatedFields;
            });
            setIsNewItemAdded(false);
            setNewItemIndex(-1);
            setTimeout(() => {
               amountRef.current[paymentIndex]?.focus();
            }, 10);
            return;
         }
      }
      setTimeout(() => {
         amountRef.current[paymentIndex]?.focus();
      }, 0);
   };

   const handleRateKeyDown = (e, index) => {
      if (e.key === 'Enter' || e.key === 'Tab') {
         e.preventDefault();
         if (isNewItemAdded && !fields[index].itemId && paymentData?.length > 0) {
            handlePaymentFieldFocus(0);
         } else {
            noteRef.current[index]?.focus();
         }
      }
   };

   const handleNoteKeyDown = (e, index) => {
      if (e.key === 'Enter' || e.key === 'Tab') {
         e.preventDefault();
         if (isNewItemAdded && !fields[index].itemId && paymentData?.length > 0) {
            handlePaymentFieldFocus(0);
         } else {
            serialNoRef.current[index]?.focus();
         }
      }
   };

   const handleSerialNoKeyDown = (e, index) => {
      if (e.key === 'Enter' || e.key === 'Tab') {
         e.preventDefault();
         if (isNewItemAdded && !fields[index].itemId && paymentData?.length > 0) {
            handlePaymentFieldFocus(0);
         } else {
            serialNo2Ref.current[index]?.focus();
         }
      }
   };

   const handleSerialNo2KeyDown = (e, index) => {
      if (e.key === 'Enter' || e.key === 'Tab') {
         e.preventDefault();
         if (isNewItemAdded && !fields[index].itemId) {
            handlePaymentFieldFocus(0);
         } else if (index === fields.length - 1) {
            if (addRef.current[index]) {
               addRef.current[index]?.focus();
            } else {
               amountRef.current[0]?.focus();
            }
         } else {
            itemRef.current[index + 1]?.focus();
         }
      }
   };

   const getData = useCallback(async () => {
      if (isOpen && data && data?.id) {
         await dispatch(getPurchaseInvoice(data.id));
      }
   }, [data, dispatch, isOpen]);

   useEffect(() => {
      if (exchange?.length > 0) {
         setFields(exchange);
      }
   }, [exchange]);

   useEffect(() => {
      if (daybookPaymentData?.length > 0) {
         const payment = daybookPaymentData?.map((payment) => {
            return { daybookName: payment.name, daybookId: payment.id, amount: 0 };
         });
         setPaymentData(payment);
      }
   }, [daybookPaymentData]);

   useEffect(() => {
      setTimeout(() => {
         itemRef.current[0]?.focus();
      }, 100);
   }, [isOpen]);

   useEffect(() => {
      getData();
   }, [getData]);

   return (
      <Modal
         isOpen={isOpen}
         onClose={handleExchangeClose}
         size="6xl"
         closeOnOverlayClick={false}
         closeOnEsc={true}
         scrollBehavior="inside">
         <ModalOverlay bg="blackAlpha.600" />
         <ModalContent
            bg={isDark ? 'gray.900' : 'white'}
            borderWidth="2px"
            borderColor={isDark ? 'gray.700' : 'gray.200'}
            borderRadius="2xl"
            boxShadow="2xl">
            <ModalHeader
               bg={
                  isDark
                     ? 'linear-gradient(to right, var(--chakra-colors-gray-800), var(--chakra-colors-gray-900))'
                     : 'linear-gradient(to right, var(--chakra-colors-blue-50), var(--chakra-colors-purple-50))'
               }
               borderTopRadius="2xl"
               borderBottomWidth="2px"
               borderColor={isDark ? 'gray.700' : 'gray.200'}
               fontSize="2xl"
               fontWeight="bold"
               color={isDark ? 'white' : 'gray.800'}>
               Add Exchange
            </ModalHeader>
            <ModalCloseButton
               color={isDark ? 'gray.400' : 'gray.500'}
               _hover={{
                  bg: isDark ? 'gray.700' : 'gray.200',
                  color: isDark ? 'white' : 'gray.700',
               }}
            />

            <ModalBody p={8}>
               {/* Exchange Items Section */}
               <Box
                  maxH="500px"
                  overflowY="auto"
                  pr={2}
                  css={{
                     '&::-webkit-scrollbar': {
                        width: '8px',
                     },
                     '&::-webkit-scrollbar-track': {
                        background: 'transparent',
                     },
                     '&::-webkit-scrollbar-thumb': {
                        background: isDark ? 'rgba(71, 85, 105, 0.5)' : 'rgba(156, 163, 175, 0.5)',
                        borderRadius: '4px',
                     },
                     '&::-webkit-scrollbar-thumb:hover': {
                        background: isDark ? 'rgba(71, 85, 105, 0.7)' : 'rgba(156, 163, 175, 0.7)',
                     },
                  }}>
                  {fields?.map((field, index) => (
                     <Box
                        key={index}
                        borderRadius="xl"
                        p={6}
                        borderWidth="2px"
                        mb={4}
                        transition="all 0.2s"
                        bg={field?.isDelete ? (isDark ? 'red.950' : 'red.50') : isDark ? 'gray.800' : 'gray.50'}
                        borderColor={
                           field?.isDelete ? (isDark ? 'red.800' : 'red.300') : isDark ? 'gray.600' : 'gray.300'
                        }
                        opacity={field?.isDelete ? 0.7 : 1}
                        _hover={{
                           borderColor: !field?.isDelete && (isDark ? 'blue.500' : 'blue.400'),
                        }}>
                        <Flex gap={6}>
                           {/* Left Section - Input Fields */}
                           <Box flex={1}>
                              <Flex gap={5} mb={4}>
                                 {/* Item Dropdown */}

                                 <Box minWidth="400px">
                                    {renderDynamicDropdown(
                                       'itemId',
                                       'Item',
                                       itemData,
                                       {
                                          value: field?.itemId,
                                          onChange: (value) =>
                                             handleExchangeOnChangeInput(null, index, value, 'itemId'),
                                          disabled: field?.isDelete,
                                          focusBorderColor: 'blue.500',
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                          },
                                          showCustomNoOptions: true,
                                          openfrom: 'item',
                                          ref: (el) => {
                                             itemRef.current[index] = el;
                                             if (
                                                index === fields?.length - 1 &&
                                                fields?.length > prevFieldsLength.current
                                             ) {
                                                setTimeout(() => el?.focus(), 0);
                                             }
                                          },
                                          onKeyDown: async (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (index === 0) {
                                                      itemRef.current[index]?.focus();
                                                   } else {
                                                      deleteRef.current[index - 1]?.focus();
                                                   }
                                                } else {
                                                   setTimeout(() => {
                                                      if (!field.itemId && index !== 0) {
                                                         handlePaymentFieldFocus(0);
                                                      } else {
                                                         rateRef.current[index]?.focus();
                                                      }
                                                   }, 300);
                                                }
                                             }

                                             if (e.key === 'Escape' || e.key === 'Esc') {
                                                e.preventDefault();
                                                if (typeof handleExchangeClose === 'function') {
                                                   handleExchangeClose();
                                                }
                                             }
                                          },
                                       },
                                       {},
                                       textColor,
                                       false,
                                       'Select Item',
                                    )}
                                 </Box>

                                 {/* Rate Input */}
                                 <InputField
                                    name="itemRate"
                                    ref={(el) => (rateRef.current[index] = el)}
                                    label="Rate"
                                    type="number"
                                    value={field.itemRate}
                                    onChange={(e) => handleExchangeOnChangeInput(e, index, null)}
                                    onKeyDown={(e) => {
                                       if (e.shiftKey && (e.key === 'Enter' || e.key === 'Tab')) {
                                          e.preventDefault();
                                          itemRef.current[index]?.focus();
                                       } else {
                                          handleRateKeyDown(e, index);
                                       }
                                    }}
                                    isDisabled={field?.isDelete} // 🔴 disable input
                                 />
                                 <InputField
                                    name="note1"
                                    ref={(el) => (noteRef.current[index] = el)}
                                    label="Note 1"
                                    type="text"
                                    value={field.note1}
                                    onChange={(e) => handleExchangeOnChangeInput(e, index, null)}
                                    onKeyDown={(e) => {
                                       if (e.shiftKey && (e.key === 'Enter' || e.key === 'Tab')) {
                                          e.preventDefault();
                                          rateRef.current[index]?.focus();
                                       } else {
                                          handleNoteKeyDown(e, index);
                                       }
                                    }}
                                    isDisabled={field?.isDelete} // 🔴 disable input
                                 />
                              </Flex>

                              {/* Serial Numbers Row */}
                              <Flex gap={5}>
                                 <InputField
                                    name="serialNo"
                                    ref={(el) => (serialNoRef.current[index] = el)}
                                    label="Serial No 1"
                                    type="text"
                                    value={field.serialNo}
                                    onChange={(e) => handleExchangeOnChangeInput(e, index, null)}
                                    onKeyDown={(e) => {
                                       if (e.shiftKey && (e.key === 'Enter' || e.key === 'Tab')) {
                                          e.preventDefault();
                                          noteRef.current[index]?.focus();
                                       } else {
                                          handleSerialNoKeyDown(e, index);
                                       }
                                    }}
                                    errorName={`serialNo_${index}`}
                                    errors={errors}
                                    isDisabled={field?.isDelete} // 🔴 disable input
                                 />
                                 <InputField
                                    name="serialNo2"
                                    ref={(el) => (serialNo2Ref.current[index] = el)}
                                    label="Serial No 2"
                                    type="text"
                                    value={field.serialNo2}
                                    onChange={(e) => handleExchangeOnChangeInput(e, index, null)}
                                    onKeyDown={(e) => {
                                       if (e.shiftKey && (e.key === 'Enter' || e.key === 'Tab')) {
                                          e.preventDefault();
                                          serialNoRef.current[index]?.focus();
                                       } else {
                                          handleSerialNo2KeyDown(e, index);
                                       }
                                    }}
                                    isDisabled={field?.isDelete} // 🔴 disable input
                                 />
                              </Flex>
                           </Box>

                           {/* Right Section - Actions */}
                           <Flex flexDirection="column" alignItems="center" gap={4}>
                              {/* IsOld Toggle */}
                              <Flex
                                 alignItems="center"
                                 gap={3}
                                 px={5}
                                 py={3}
                                 borderRadius="lg"
                                 borderWidth="2px"
                                 bg={isDark ? 'gray.700' : 'white'}
                                 borderColor={isDark ? 'gray.600' : 'gray.300'}>
                                 <Text fontSize="sm" fontWeight="semibold" color={isDark ? 'gray.300' : 'gray.700'}>
                                    IsOld
                                 </Text>
                                 <Switch
                                    ref={(el) => (isOldRef.current[index] = el)}
                                    isChecked={field.isOld}
                                    onChange={() => handleExchangeOnChangeInput(!field.isOld, index, null, 'isOld')}
                                    colorScheme="blue"
                                    size="lg"
                                 />
                              </Flex>

                              {/* Action Buttons */}
                              <Flex gap={2}>
                                 {index === fields?.length - 1 && (
                                    <IconButton
                                       ref={(el) => (addRef.current[index] = el)}
                                       onClick={addField}
                                       icon={<AddIcon />}
                                       colorScheme="green"
                                       aria-label="Add"
                                       boxShadow="lg"
                                       _hover={{ boxShadow: 'xl' }}
                                       _focus={{ outlineColor: 'blue.500 ' }}
                                       onKeyDown={(e) => {
                                          if (e.key === 'ArrowRight') {
                                             e.preventDefault();
                                             deleteRef.current[index]?.focus();
                                          }
                                          if (e.shiftKey && (e.key === 'Enter' || e.key === 'Tab')) {
                                             e.preventDefault();
                                             serialNo2Ref.current[index]?.focus();
                                          }
                                       }}
                                    />
                                 )}
                                 <IconButton
                                    ref={(el) => (deleteRef.current[index] = el)}
                                    onClick={() => removeField(index)}
                                    icon={<CloseIcon />}
                                    colorScheme="red"
                                    aria-label="Remove"
                                    boxShadow="lg"
                                    _hover={{ boxShadow: 'xl' }}
                                    _focus={{ outlineColor: 'blue.500 ' }}
                                    onKeyDown={(e) => {
                                       if (e.key === 'ArrowLeft') {
                                          e.preventDefault();
                                          addRef.current[index]?.focus();
                                       }
                                    }}
                                 />
                              </Flex>
                           </Flex>
                        </Flex>
                     </Box>
                  ))}
               </Box>

               {/* Payments Section */}
               <Box mt={8}>
                  <Box mb={6} pb={4} borderBottomWidth="2px" borderColor={isDark ? 'gray.700' : 'gray.200'}>
                     <Text fontSize="xl" fontWeight="bold" color={isDark ? 'green.400' : 'green.600'}>
                        Payments
                     </Text>
                  </Box>

                  <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                     {paymentData?.map((payment, idx) => (
                        <GridItem key={idx}>
                           <FormControl>
                              <FormLabel fontSize="sm" fontWeight="semibold" color={isDark ? 'gray.300' : 'gray.700'}>
                                 {payment.daybookName.toUpperCase()} AMOUNT
                              </FormLabel>
                              <Input
                                 ref={(el) => (amountRef.current[idx] = el)}
                                 type="number"
                                 name="amount"
                                 value={payment.amount}
                                 onChange={(e) => handlePaymentOnChange(e, idx)}
                                 onFocus={() => {
                                    if (isNewItemAdded && newItemIndex >= 0 && newItemIndex < fields?.length) {
                                       const itemToCheck = fields[newItemIndex];
                                       if (isItemEmpty(itemToCheck)) {
                                          setFields((prevFields) => {
                                             const updatedFields = prevFields.filter(
                                                (_, index) => index !== newItemIndex,
                                             );
                                             return updatedFields;
                                          });
                                          setIsNewItemAdded(false);
                                          setNewItemIndex(-1);
                                       }
                                    }
                                 }}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                       e.preventDefault();
                                       const nextRef = amountRef.current[idx + 1] || saveButtonRef.current;
                                       nextRef?.focus();
                                    }
                                 }}
                                 placeholder="0.00"
                                 bg={isDark ? 'gray.700' : 'white'}
                                 borderColor={isDark ? 'gray.600' : 'gray.300'}
                                 color={isDark ? 'white' : 'gray.900'}
                                 _placeholder={{ color: isDark ? 'gray.500' : 'gray.400' }}
                                 _focus={{
                                    borderColor: 'green.500',
                                    boxShadow: '0 0 0 1px var(--chakra-colors-green-500)',
                                 }}
                              />
                           </FormControl>
                        </GridItem>
                     ))}
                  </Grid>
               </Box>
            </ModalBody>

            <ModalFooter
               bg={isDark ? 'gray.800' : 'gray.50'}
               borderTopWidth="2px"
               borderBottomRadius="2xl"
               borderColor={isDark ? 'gray.700' : 'gray.200'}
               gap={3}>
               <Button
                  ref={saveButtonRef}
                  onClick={handleExchange}
                  isLoading={isLoading}
                  loadingText="Saving..."
                  bgGradient="linear(to-r, blue.500, blue.600)"
                  _hover={{
                     bgGradient: 'linear(to-r, blue.600, blue.700)',
                  }}
                  _focus={{ outlineColor: 'blue.500 ' }}
                  color="white"
                  fontWeight="semibold"
                  boxShadow="lg"
                  // _hover={{ boxShadow: 'xl' }}
                  px={8}
                  py={3}
                  onKeyDown={(e) => {
                     if (e.key === 'ArrowRight') {
                        e.preventDefault();
                        closeButtonRef.current?.focus();
                     }
                  }}>
                  Save
               </Button>
               <Button
                  ref={closeButtonRef}
                  onClick={handleExchangeClose}
                  colorScheme="red"
                  fontWeight="semibold"
                  boxShadow="lg"
                  _hover={{ boxShadow: 'xl' }}
                  _focus={{ outlineColor: 'blue.500 ' }}
                  px={8}
                  py={3}
                  onKeyDown={(e) => {
                     if (e.key === 'ArrowLeft') {
                        e.preventDefault();
                        saveButtonRef.current?.focus();
                     }
                  }}>
                  Close
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default ExchangeModal;
